export default __webpack_public_path__ + "static/media/cf6d1f3e-7fee-480e-ac0d-68db33940f69.1f614536.JPG";